var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6625 9.75C12.225 9.75 12.72 9.4425 12.975 8.9775L15.66 4.11C15.9375 3.615 15.5775 3 15.0075 3H3.9075L3.2025 1.5H0.75V3H2.25L4.95 8.6925L3.9375 10.5225C3.39 11.5275 4.11 12.75 5.25 12.75H14.25V11.25H5.25L6.075 9.75H11.6625ZM4.62 4.5H13.7325L11.6625 8.25H6.3975L4.62 4.5ZM5.25 13.5C4.425 13.5 3.7575 14.175 3.7575 15C3.7575 15.825 4.425 16.5 5.25 16.5C6.075 16.5 6.75 15.825 6.75 15C6.75 14.175 6.075 13.5 5.25 13.5ZM12.75 13.5C11.925 13.5 11.2575 14.175 11.2575 15C11.2575 15.825 11.925 16.5 12.75 16.5C13.575 16.5 14.25 15.825 14.25 15C14.25 14.175 13.575 13.5 12.75 13.5Z",
    fill: "#333333"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.559ca3031a2bea9c5c8cbd502870b225.svg";
export { ForwardRef as ReactComponent };